<div class="nav-up-list-item">
  <ng-content></ng-content>
</div>
